import React from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

import { api } from "../../../Services/Api";
import Loading from "../../../Components/Loading";
import { SignInError } from "../../../Theme";
import { Form, InputGroup, Title, Step } from "../style";

export default function StepOne() {
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [passworddError, setPasswordError] = React.useState(false);
  const [passworddErrorLenght, setPasswordLenghtError] = React.useState(false);
  const [isSignInError, setIsSignInError] = React.useState({
    status: false,
    message: "",
  });

  const [registered, setRegistered] = React.useState(false);

  function handleSubmit(event) {
    event.preventDefault();
    setPasswordError(false);
    setIsSignInError({ status: false });
    setPasswordLenghtError(false);

    const password = event.target.password.value;
    const replyPassword = event.target.password_reply.value;

    if (password.length < 6) {
      setPasswordLenghtError(true);
      return;
    }

    if (password !== replyPassword) {
      setPasswordError(true);
      return;
    }

    setLoading(true);

    const body = {
      ...JSON.parse(localStorage.getItem("signInData")),
      email: event.target.email.value,
      password: password,
    };

    axios
      .post(process.env.REACT_APP_API_URL + "/auth/register", body)
      .then(({ data }) => {
        if (window.fbq) {
          window.fbq("track", "CompleteRegistration");
        }
        window.localStorage.setItem("token", data.accessToken);
        setRegistered(true);
      })
      .catch((err) => {
        setLoading(false);
        setIsSignInError({
          status: true,
          message:
            "Erro ao realizar cadastro cadastrar. Tente novamente, por favor.",
        });
      });
  }

  React.useEffect(() => {
    if (registered) {
      const getToken = () => {
        const token = window.localStorage.getItem("token") || "";
        return `Bearer ${token} `;
      };
      api.defaults.headers = {
        authorization: getToken(),
      };
      const lineOfBusiness = JSON.parse(localStorage.getItem("signInData"))
        .lineOfBusiness;

      if (lineOfBusiness === "Açaiteria")
        history.push("/cardapio?openDialog=acai-template-notify");
      else history.push("/");
    }
  }, [registered]);

  return (
    <Step>
      <Title>Quase lá ...</Title>
      <Form onSubmit={handleSubmit}>
        <InputGroup>
          <label>Digite o seu email</label>
          <input
            required
            type="email"
            placeholder="ex: meu@gmail.com"
            name="email"
          />
        </InputGroup>
        <InputGroup>
          <label>Digite uma senha</label>
          <input required type="text" placeholder="***" name="password" />
        </InputGroup>
        <InputGroup>
          <label>Confirme a sua senha</label>
          <input required type="text" placeholder="***" name="password_reply" />
        </InputGroup>
        {passworddError && (
          <SignInError style={{ color: "red" }}>Senha não confere</SignInError>
        )}
        {passworddErrorLenght && (
          <SignInError style={{ color: "red" }}>
            A senha precisa ter ao menos 6 caracteres
          </SignInError>
        )}
        {isSignInError.status && (
          <SignInError style={{ color: "red" }}>
            {isSignInError.message}
          </SignInError>
        )}
        <button>Finalizar</button>
        {loading && <Loading />}
      </Form>
    </Step>
  );
}
